import React, { useState, useEffect } from 'react'
import { Button, Grid } from '@material-ui/core'
import MaterialTable from 'material-table'
import { Modal31 } from '../../Modals/ModalSec3/Modal31'
import AddIcon from '@material-ui/icons/Add'
import { GetAttachedDocuments } from '../../../../../services/AsistenciaTecnica/get'
import swal from 'sweetalert'
import DeleteIcon from '@mui/icons-material/Delete'
import {
  DeleteAzureBlobStorageService,
  DownloadAzureBlobStorageService,
} from '../../../../../services/AsistenciaTecnica/create'
import DownloadIcon from '@mui/icons-material/Download'

export const Table33 = ({ IdTechnicalAssistanceAnswer, formik }) => {
  const [open, setOpen] = useState(false)
  const [data, setData] = useState([])

  const getAttachedDocumentsList = async () => {
    try {
      const response = await GetAttachedDocuments({
        IdForm: IdTechnicalAssistanceAnswer,
        RelatedFormField: 74,
      })
      if (response.Success) {
        if (response.Data.length >= 1) {
          formik('validateTable33', true)
        } else {
          formik('validateTable33', false)
        }
        var item = []
        for (var i = 0; i < response.Data.length; i++) {
          item[i] = {
            ...response.Data[i],
            FileName: response.Data[i].FileName.split('.').shift(),
          }
        }
        setData(item)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleDelete = async (id) => {
    try {
      const response = await DeleteAzureBlobStorageService(id)

      if (response.Success) {
        swal({
          title: '¡Archivo eliminado exitosamente!',
          icon: 'success',
        })
        getAttachedDocumentsList()
      }
    } catch (error) {
      console.log(error)
    }
  }

  const downloadPDF = async (id, FileName) => {
    try {
      const response = await DownloadAzureBlobStorageService(id)
      if (response.Success) {
        const byteCharacters = atob(response.Data.FileContents)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const filename = FileName
        const blob = new Blob([byteArray], { type: 'application/pdf' })
        const link = document.createElement('a')

        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        link.click()
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (
      IdTechnicalAssistanceAnswer !== '' &&
      IdTechnicalAssistanceAnswer !== null
    )
      getAttachedDocumentsList()
  }, [IdTechnicalAssistanceAnswer])

  const columns = [
    {
      title: 'Nombre Archivo',
      field: 'FileName',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      editable: 'never',
    },
    {
      title: 'Extensión',
      field: 'FileExtension',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      editable: 'never',
    },
    {
      title: 'Descripción',
      field: 'Description',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      editable: 'never',
    },
    {
      title: 'Tamaño',
      field: 'SizeMB',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      editable: 'never',
    },
  ]

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={data}
            actions={[
              {
                icon: () => (
                  <Button
                    variant="contained"
                    color="success"
                    style={{ backgroundColor: '#27C27D', color: '#FFFFFF' }}
                    startIcon={<AddIcon style={{ color: 'white' }} />}
                  >
                    Agregar registro
                  </Button>
                ),
                tooltip: 'Agregar',
                position: 'toolbar',
                onClick: () => {
                  setOpen(true)
                },
              },
              {
                icon: () => <DeleteIcon style={{ color: 'red' }} />,
                tooltip: 'Eliminar registro',
                onClick: (event, rowData) => {
                  swal({
                    title: '¿Está seguro de eliminar el registro?',
                    icon: 'warning',
                    buttons: ['No', 'Si'],
                    dangerMode: true,
                  }).then(function (isConfirm) {
                    if (isConfirm) {
                      handleDelete(rowData.IdAttachedDocument)
                    }
                  })
                },
              },
              {
                icon: () => <DownloadIcon color="success" />,
                tooltip: 'Descargar',
                onClick: (event, rowData) => {
                  downloadPDF(rowData.IdAttachedDocument, rowData.FileName)
                },
              },
            ]}
            onSelectionChange={(selectedRows) => console.log(selectedRows)}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',

              exportFileName: 'TableData',
              addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              toolbarButtonAlignment: 'left',
              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),

              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
          />
        </Grid>
        <Modal31
          open={open}
          setOpen={setOpen}
          IdTechnicalAssistanceAnswer={IdTechnicalAssistanceAnswer}
          getAttachedDocumentsList={getAttachedDocumentsList}
          RelatedFormField={74}
        />
      </Grid>
    </>
  )
}
